import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components


import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import styles from "../../../../services/ServicesSections.module.scss";




export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
 
        
        <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>Auckland Measurecamp 2019 Talk: The Fake Reviews Economy</h3>
          <p> 
          Scott's talk from Auckland Measurecamp June 2019 and WAW Melbourne June 2019.
          <br /><br /> 
          It looks at how the internet is awash with fake reviews, the shady economy it has spawned and ways we might mitigate against them.
          <br /><br /> 
          This has become a massive issue across all types of platforms where reviews are used or an important componenet.
          <br /><br /> 
          Even sites with so called “verified” reviews are rife with fake reviews. Examples include booking.com: where hotel owners “pay people” to “stay” at there hotel and then write a nice review; or amazon.com where vendors are buying real addreses and shipping products to them - solely for the purpose of being able to write a fake review for said product… 
          <br /><br /> 
          
          </p>
 
          </GridItem>

          <GridItem xs={12} sm={10} md={10}>
                <Card
                  raised
                  //background
                  //style={{
                  //  backgroundImage: "url('/img/sections/services/google-analytics-training/1.jpg')",
                  //}}
                >
                  
                  <CardActionArea>
                    <CardMedia
                      component="iframe"
                      alt="Contemplative Reptile"
                      //className={classes.media}
                      height="500"
                      image="https://docs.google.com/presentation/d/e/2PACX-1vSfzo4gMKnG1SuJjVd6uRV2gGMKvaXAiCR_qPCg2YqxWuReZ9FDrKY1kkLDBI8qMq9SjhyiF3FQT0_M/embed?start=false&loop=false&delayms=3000"
                      //title="Contemplative Reptile"
                    />

                  </CardActionArea>
                </Card>  
                <p><br /><br /></p>       
              </GridItem>
          

        


      </GridContainer>
    </div>

  );
}
